import { useQuery } from "@msuite/ui/query";
import { DataTable } from "@msuite/ui/table";
import { responseHandler } from "@msuite/ui/utils";
import { guardArray } from "@msuite/utils/array";
import { useMemo } from "react";
import { client } from "@/hono";
import { useTeams } from "@/hooks/use-teams";
import { OrganizationSettingsAlertMenu } from "@/sites/organization/settings/organization-settings-alerts/organization-settings-alerts-menu";
import { createColumns } from "./table-config";

export function OrganizationSettingsAlerts() {
	/** Query */
	const {
		data: alerts,
		refetch,
		isLoading,
		queryKey,
	} = useQuery({
		queryKey: ["organization", "alerts"],
		queryFn: async () => {
			const response = await client.organizations.alerts.$get();
			const data = await responseHandler(response);
			return data.alerts;
		},
	});
	const { teams } = useTeams();

	/** Computed */
	const columns = useMemo(() => createColumns(teams), [teams]);

	/** Render */
	return (
		<DataTable
			data={guardArray(alerts)}
			columns={columns}
			persistenceKey="organization-alerts-table"
			menu={<OrganizationSettingsAlertMenu />}
			refetch={refetch}
			queryKey={queryKey}
			isLoading={isLoading}
		/>
	);
}
